import { EventEmitter, Injectable, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import { Observable, ReplaySubject } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { ExcessValueTypeEnum } from 'src/app/shared/app-common-enum';
import { CommonDataModel } from 'src/app/shared/common-data-model';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { PopupDialogComponent } from 'src/app/shared/popup-dialog/popup-dialog.component';
import { PermissionDataModel } from '../auth/permission-data-model';
import { CommonConstants } from '../constants/common-constants';
import { ApiCommonService } from './api-common.service';

@Injectable({
    providedIn: 'root',
})

export class CommonService {
    static isUserPermissionMapped = false;
    oidCNFDetails: any;
    commonDataModel = new CommonDataModel();
    permissionDataModel = new PermissionDataModel();
    permissionDataModelList = this.permissionDataModel.permissionListModel;
    loggedUserModel = this.commonDataModel.loggedUserModel;

    private uncategorizedServicesCountSubject = new ReplaySubject<any>(0);
    public uncategorizedServicesCount$ = this.uncategorizedServicesCountSubject.asObservable();

    constructor(
        private apiCommonService: ApiCommonService,
        private dialog: MatDialog) {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            this.mappingPermission();
        }
    }

    @Output() setSideNavToggleValue: EventEmitter<any> = new EventEmitter();

    userDetails = { permission: 'admin' }; // Please replace with the stored logged in user details

    sendtSideNavBarToggle(data: boolean) {
        return this.setSideNavToggleValue.emit(data);
    }

    getTenentId(): number {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return +this.oidCNFDetails.tenantId;
        }
        return null;
    }

    getTenentGuid(): number {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.tenantGuid;
        }
        return null;
    }

    getUserId(): number {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return +this.oidCNFDetails.userId;
        }
        return null;
    }

    getUserName(): number {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.displayName;
        }
        return null;
    }

    getTGeocode(): number {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            this.oidCNFDetails.tGeocode = this.oidCNFDetails.tGeocode.split(',').map(item => parseInt(item.trim()));
            this.oidCNFDetails.tGeocode = {
                lat: this.oidCNFDetails.tGeocode[0],
                long: this.oidCNFDetails.tGeocode[1]
            };
            return this.oidCNFDetails.tGeocode;
        }
        return null;
    }

    getTZipcode(): number {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.tZipcode;
        }
        return null;
    }

    getTCity(): number {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.tCity;
        }
        return null;
    }

    getTState(): number {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.tState;
        }
        return null;
    }

    getTFullAddress(): string {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.tFullAddress;
        }
        return null;
    }

    getRoleId(): any {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.roleId;
        }
        return null;
    }

    getTenentCode(): number {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.code;
        }
        return null;
    }

    getUserEmail(): string {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.email;
        }
        return null;
    }

    getNewTaxConfigAppliedDate(): string {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.newTaxConfigAppliedDate;
        }
        return null;
    }

    // National Zipcode

    getZipcodeGridRecords(event: any, queryparams: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Locations/ZIP/BrowseAsync', event, queryparams, statusQuery, '');
    }

    AddZipcode(data: any): Observable<any> {
        return this.apiCommonService.post(`Locations/ZIP/Add`, data);
    }

    UpdateZipcode(data: any): Observable<any> {
        return this.apiCommonService.post(`/Locations/ZIP/Update`, data);
    }

    DeleteZipcode(data: any): Observable<any> {
        return this.apiCommonService.post(`/Locations/ZIP/ActivateDeactivate`, data);
    }

    getZipcodeDetails(searchQuery: string): Observable<any> {
        return this.apiCommonService.get(`Locations/ZIP/Edit?zIP=${searchQuery}`);
    }

    exportZipcode(event: any, searchQuery: string, queryString: string): Observable<object> {
        return this.apiCommonService.export('Locations/ZIP/Export', event, searchQuery, queryString, '');
    }

    downloadTemplate(): Observable<any> {
        return this.apiCommonService.get(`zipcode-bulk-upload-template`);
    }

    postZipcodeInExcel(data: object): Observable<any> {
        return this.apiCommonService.post('Locations/ZIP/ImportExcel', data);
    }

    // End

    // Customer and Lead
    getLeadSources(query: string): Observable<any> {
        return this.apiCommonService.get(`leadSources/LookUp?${query}`);
    }

    getEmployees(IncludeEmployee: any, searchQuery?: string): Observable<any> {
        return this.apiCommonService.get(`Employees/LookUp?IncludeEmployee=${IncludeEmployee}&${searchQuery ? searchQuery : ''}`);
    }

    getIndustries(): Observable<any> {
        return this.apiCommonService.get(`Industry/LookUp`);
    }

    getCountries(): Observable<any> {
        return this.apiCommonService.get(`Locations/Country/LookUp`);
    }

    getProvinces(countryId: string): Observable<any> {
        return this.apiCommonService.get(`Locations/Province/LookUp?CountryId=${countryId}`);
    }

    getPostalCodes(searchQuery: string): Observable<any> {
        return this.apiCommonService.get(`Locations/ZIP/LookUp?SearchQuery=${searchQuery}`);
    }

    getAccounts(searchQuery: string): Observable<any> {
        return this.apiCommonService.get(`Accounts/LookUp?searchQuery=${searchQuery}`);
    }

    getYears(): Observable<any> {
        return this.apiCommonService.get(`Admin/YearsLookUp`);
    }

    getPostalCodeDetails(searchQuery: string): Observable<any> {
        return this.apiCommonService.get(`Locations/ZIP/GetZipCode?ZIP=${searchQuery}`);
    }

    // End

    // Start Notes
    getNotesGridRecords(event: any, queryparams: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Vehicle/NoteList', event, queryparams, '', '');
    }

    getVehicleNotes(vehicleNotesId: string): Observable<any> {
        return this.apiCommonService.get('Vehicle/Note?VehicleNoteId=' + vehicleNotesId);
    }

    createNotes(data: object): Observable<object> {
        return this.apiCommonService.put('Vehicle/AddNotes', data);
    }
    // End Notes

    // Contact List

    getContactGridRecords(event: any, searchQuery: string, queryString: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Contacts', event, searchQuery, queryString, '');
    }

    // Update Status
    updateContactStatus(inputData: object): Observable<object> {
        return this.apiCommonService.update('Contacts/Delete', inputData);
    }

    // End

    getMenuByPermission(menuObject: any) {
        this.permissionDataModelList.filter(list => {
            menuObject.filter(menuList => {
                if (list.permissionName === menuList.permission) {
                    return menuList.isActive = list.isChecked;
                }
                if (menuList.items.length !== 0) {
                    menuList.items.filter(subMenuList => {
                        if (list.permissionName === subMenuList.permission) {
                            return subMenuList.isActive = list.isChecked;
                        }
                    });
                }
            });
        });
        return menuObject;
    }

    // Object Mapping
    objectMapping(mappingObject: object, sourceObject: object) {
        Object.keys(sourceObject).map((key, index) => {
            if (mappingObject.hasOwnProperty(key)) {
                mappingObject[key] = sourceObject[key];
            }
        });
    }

    // Downloading File
    downloadBolbFile(body: any, options: any, filename: any) {
        const blob = new Blob([body], options);
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    downloadBolbMultipleFiles(files: { body: any, options: any, filename: string }[]) {
        files.forEach(file => {
            const blob = new Blob([file.body], file.options);
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, file.filename);
            } else {
                const link = document.createElement('a');
                if (link.download !== undefined) {
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', file.filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        });
    }

    // Downloading File
    viewBolbFile(body: any, options: any, filename: any) {
        const blob = new Blob([body], options);
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            }
        }
    }

    // Object Mapping value or Zero
    getObjectWithZeroOrValue(sourceObject: object): any {
        Object.keys(sourceObject).map((key, index) => {
            sourceObject[key] = sourceObject[key] ? sourceObject[key] : 0;
        }
        );
        return sourceObject;
    }

    // object properties values converted to string except Boolean
    public getObjectValueAsString(sourceObject: object): any {
        Object.keys(sourceObject).map((key, index) => {
            sourceObject[key] = sourceObject[key] && typeof sourceObject[key] !== 'boolean' ? sourceObject[key].toString() : sourceObject[key];
        }
        );
        return sourceObject;
    }
    // Object Mapping value or Zero
    getObjectWithEmptyStringOrValue(sourceObject: object): any {
        Object.keys(sourceObject).map((key, index) => {
            sourceObject[key] = sourceObject[key] || typeof sourceObject[key] === 'number' ? sourceObject[key] : '';
        }
        );
        return sourceObject;
    }

    // This method is for Deep Copy, Object.assign will not deep copy or nested objects
    objectDeepCopy(obj: any) {
        let copy;
        // Handle the 3 simple types, and null or undefined
        if (null == obj || 'object' !== typeof obj) { return obj; }
        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }
        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.objectDeepCopy(obj[i]);
            }
            return copy;
        }
        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) { copy[attr] = this.objectDeepCopy(obj[attr]); }
            }
            return copy;
        }
        throw new Error('Unable to copy obj! Its type isn\'t supported.');
    }

    // round off values with precision
    roundNumber(num: any, scale: any) {
        if (Math.round(num) !== num) {
            if (Math.pow(0.1, scale) > num) {
                return 0;
            }
            const sign = Math.sign(num);
            const arr = ('' + Math.abs(num)).split('.');
            if (arr.length > 1) {
                if (arr[1].length > scale) {
                    const integ = +arr[0] * Math.pow(10, scale);
                    let dec = integ + (+arr[1].slice(0, scale) + Math.pow(10, scale));
                    const proc = +arr[1].slice(scale, scale + 1);
                    if (proc >= 5) {
                        dec = dec + 1;
                    }
                    dec = sign * (dec - Math.pow(10, scale)) / Math.pow(10, scale);
                    return dec;
                }
            }
        }
        return num;
    }

    // get Today Date
    setTodayDate() {
        return new Date(new Date().setHours(0, 0, 0, 0));
    }

    setTomorrowDate() {
        return new Date(new Date().getTime() + (24 * 60 * 60 * 1000));
    }

    convertedDateTimeFormat(date: Date) {
        return (moment(date).format('YYYY-MM-DD') + 'T' + moment(date).format('HH:mm:ss'));
    }

    getFreightShopperRates(data: object): Observable<object> {
        return this.apiCommonService.post('Rates', data);
    }

    saveRecentQuote(data: object): Observable<object> {
        return this.apiCommonService.post('Orders/RecentQuotes', data);
    }

    saveProNumber(data: Object): Observable<object> {
        return this.apiCommonService.post('Orders/UpdateCarrierCosts', data);
    }

    getLocationType(): Observable<object> {
        return this.apiCommonService.get(`Orders/LocationTypesLookup`);
    }

    getCarriersList(queryString: string): Observable<object> {
        return this.apiCommonService.get(`carrier/lookup?${queryString}`);
    }

    getAccessorials(): Observable<object> {
        return this.apiCommonService.get(`Carrier/AccessorialsLookup`);
    }

    getRoyaltyAdFundTypes(): Observable<object> {
        return this.apiCommonService.get(`RoyaltyPlan/Lookup`);
    }

    getOrderStatus(queryString: string): Observable<object> {
        return this.apiCommonService.get(`Common/OrderStatusLookup?${queryString}`);
    }

    getContainers(orderId: string): Observable<object> {
        return this.apiCommonService.get(`Quotes/Containers?OrderId=${orderId}`);
    }

    getContainerDetails(ItemContainerId: number): Observable<any> {
        return this.apiCommonService.get(`Quotes/ContainerModifiers?ItemContainerId=${ItemContainerId}`);
    }

    getContainerSummary(containerId: number): Observable<object> {
        return this.apiCommonService.get(`Quotes/ContainerSummary?ItemContainerId=${containerId}`);
    }

    getOrderDocumentsGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Documents', event, searchQuery, statusQuery, '');
    }

    deleteOrderDocument(data: object): Observable<object> {
        return this.apiCommonService.put('Documents/Delete', data);
    }

    documentApplyToAllJobs(data: any): Observable<object> {
        return this.apiCommonService.put('Documents/ApplyToAllJobs', data);
    }

    orderUploadDocument(data: object, queryString: any): Observable<object> {
        return this.apiCommonService.post(`Documents/UploadDocument?${queryString}`, data);
    }

    getDocumentFile(id: number): Observable<object> {
        return this.apiCommonService.fileDownload(`Documents/Download?Id=${id}`);
    }

    getAllDocumentFile(documentTypeId: any, orderId: any): Observable<object> {
        return this.apiCommonService.fileDownload(`Documents/DownloadAll?DocumentTypeId=${documentTypeId}&OrderId=${orderId}`);
    }

    getHouseBillTypeLookup(): Observable<any> {
        return this.apiCommonService.get(`Documents/HouseBillTypeLookup`);
    }

    postPickupDate(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/UpdatePickupDateHouseBillByOrderId`, data);
    }

    deletePickupDate(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/RemovePickupDateHouseBillByOrderId`, data);
    }

    getOrderMaterialsGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Quotes/AdditonalMaterials', event, searchQuery, statusQuery, '');
    }

    getModifiersBreakUp(containerId: number): Observable<any> {
        return this.apiCommonService.get(`Quotes/ModifiersLaborBreakup?ItemContainerId=${containerId}`);
    }

    getOrderTotals(data: any): Observable<any> {
        return this.apiCommonService.get(`Quotes/Totals?${data}`);
    }

    getQuotePackaging(id: any): Observable<any> {
        return this.apiCommonService.get(`Quotes/Packaging?Id=${id}`);
    }

    publishDocument(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/PublishHouseBill`, data);
    }

    viewDocument(data: any): Observable<any> {
        return this.apiCommonService.fileDownloadForPost(`Documents/ViewHouseBill`, data);
    }

    quoteViewDocument(data: any): Observable<any> {
        return this.apiCommonService.fileDownloadForPost(`Documents/ViewQuoteEstimate`, data);
    }

    quotePublishDocument(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/PublishQuoteEstimate`, data);
    }

    shippingLabelViewDocument(data: any): Observable<any> {
        return this.apiCommonService.fileDownloadForPost(`Documents/ViewShippingLabel`, data);
    }

    shippingLabelPublishDocument(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/PublishShippingLabel`, data);
    }

    invoiceViewDocument(data: any): Observable<any> {
        return this.apiCommonService.fileDownloadForPost(`Documents/ViewInvoice`, data);
    }

    invoicePublishDocument(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/PublishInvoice`, data);
    }

    bolViewDocument(data: any): Observable<any> {
        return this.apiCommonService.fileDownloadForPost(`Documents/ViewBol`, data);
    }

    bolPublishDocument(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/PublishBOl`, data);
    }

    cutSheetViewDocument(data: any): Observable<any> {
        return this.apiCommonService.fileDownloadForPost(`Documents/ViewCutSheet`, data);
    }

    cutSheetPublishDocument(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/PublishCutSheet`, data);
    }

    requestForPriceDocument(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/RequestForPrice`, data);
    }

    getAccountBoxMappingRecords(query: any): Observable<any> {
        return this.apiCommonService.get(`Accounts/BrowseAccountContainers?${query}`);
    }

    notificationOfArrivalDocument(data: any): Observable<any> {
        return this.apiCommonService.post(`Documents/NotificationOfArrival`, data);
    }

    SendEmailDocument(data: any): Observable<any> {
        return this.apiCommonService.post(`Common/SendEmail`, data);
    }

    updateOrderModifier(data: any) {
        return this.apiCommonService.post(`Common/UpdateModifiers`, data);
    }

    updateOrderPackaging(data: any) {
        return this.apiCommonService.post(`Common/UpdatePackaging`, data);
    }

    getQuoteContainers(orderId: any) {
        return this.apiCommonService.get(`Common/ItemContainers?OrderId=${orderId}`);
    }

    getQuoteCarrierDetails(orderId: any) {
        return this.apiCommonService.get(`Common/CarrierDetails?OrderId=${orderId}`);
    }

    getQuoteMaterialGridRecords(event: any, searchQuery: string, filterQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Quotes/Materials', event, searchQuery, '', filterQuery);
    }

    getAppointmentTypes() {
        return this.apiCommonService.get(`Appointment/AppointmentTypeLookup`);
    }

    createAppointment(data: any) {
        return this.apiCommonService.post(`Appointment`, data);
    }

    getAppointmentGridRecords(event: any, queryparams: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Appointment', event, queryparams, '', '');
    }

    getAppointmentsForCalView(queryparams: string): Observable<any> {
        return this.apiCommonService.get(`Appointment?${queryparams}`);
    }

    createFutureUseContainer(data: any): Observable<any> {
        return this.apiCommonService.post('Container/Future', data);
    }

    // getConfirmationPopup(message: any) {
    getConfirmationPopup(
        message: any, cancelLabel?: string, confirmLabel?: string, isHideCrossButton?: boolean, titleText?: string, isShowTitle?: boolean) {
        return new Promise((resolve, reject) => {
            this.dialog.open(ConfirmDialogComponent, {
                panelClass: 'confirm_layout',
                hasBackdrop: false,
                data: {
                    message: message ? message : 'Are you Sure you to continue ?',
                    cancelLabel: cancelLabel ? cancelLabel : 'No',
                    confirmLabel: confirmLabel ? confirmLabel : 'Yes',
                    isShowCrossButton: isHideCrossButton ? false : true,
                    titleText: titleText ? titleText : 'Are you sure?',
                    isShowTitle: isShowTitle !== undefined || isShowTitle ? isShowTitle : true,
                },
            }).afterClosed()
                .subscribe((response: { confirmResult: boolean }) => {
                    resolve(response.confirmResult);
                });
        });
    }

    getMessagePopup(message: any, isShowIgnoreButton?: boolean) {
        return new Promise((resolve, reject) => {
            this.dialog.open(PopupDialogComponent, {
                panelClass: 'confirm_layout',
                hasBackdrop: false,
                data: {
                    message: message ? message : 'Are you Sure you to continue ?',
                    isShowIgnoreButton
                },
            }).afterClosed()
                .subscribe((response: { confirmResult: boolean }) => {
                    resolve(response.confirmResult);
                });
        });
    }

    // Calculation functions start
    marginPercentageUsingMarkupAndTotal(markup: number, total: number): number {
        if (total && markup) {
            return parseFloat(((markup / total) * 100).toFixed(2));
        }
        return 0.0;
    }

    markupPercentageUsingMarkupAndCost(markup: number, cost: number): number {
        if (cost) {
            return parseFloat(((markup / cost) * 100).toFixed(2));
        }
        return 0.0;
    }

    markupValueUsingMarkupAndCost(total: number, cost: number): number {
        if (total) {
            return parseFloat((total - cost).toFixed(2));
        }
        return 0.0;
    }

    markupValueUsingCostAndMarkupPercentage(cost: number, markupPercentage: number): number {
        if (cost) {
            return parseFloat(((cost * markupPercentage) / 100).toFixed(2));
        }
        return 0.0;
    }

    totalUsingCostAndMarginPercentage(cost: number, marginPercentage: number): number {
        return (-100 * cost) / (marginPercentage - 100);
    }

    totalUsingMarkupAndCost(markup: number, cost: number) {
        return parseFloat((markup + cost).toFixed(2));
    }
    // Calculation functions end

    getCorporateViews(): Observable<object> {
        return this.apiCommonService.get(`Corporate/CorporateCardview`);
    }

    createOrderNote(data: object): Observable<any> {
        return this.apiCommonService.post('Orders/Notes', data);
    }

    gerOrderNotes(queryString: string): Observable<object> {
        return this.apiCommonService.get(`Orders/Notes?${queryString}`);
    }

    cloneOrder(data: any) {
        return this.apiCommonService.post('Orders/Clone', data);
    }

    orderBulkUpdate(data: any) {
        return this.apiCommonService.post('Jobs/BulkStatusUpdate', data);
    }

    getDocumentConfig(id: string, documentTypeId?: any): Observable<any> {
        return this.apiCommonService.get(`Documents/DocumentConfigsByOrderId?OrderId=${id}&DocumentType=${documentTypeId ? documentTypeId : 0}`);
    }

    getOverviewLeftMenuByOrderId(id: string): Observable<any> {
        return this.apiCommonService.get(`Orders/LeftMenuByOrderId?OrderId=${id}`);
    }

    updateOrderExcessValue(data: any) {
        return this.apiCommonService.post('Common/ExcessValue', data);
    }

    gerAccountNotes(queryString: string): Observable<object> {
        return this.apiCommonService.get(`Accounts/BrowseNotes?${queryString}`);
    }

    createAccountNote(data: object): Observable<any> {
        return this.apiCommonService.post('Accounts/AddNotes', data);
    }

    getDateObjectFromTimeString(time: string) {
        const todyaDate = new Date();
        const timeArray = time.split(':').map(Number);
        return new Date(
            todyaDate.getFullYear(), todyaDate.getMonth(), todyaDate.getDate(),
            timeArray[0], timeArray[1], timeArray[2]
        );
    }

    getTimeStringFromDateObjectg(dateValue: any) {
        const date = new Date(dateValue);
        return `${date.getHours() < 10 ? '0' + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()}:${date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()}`;
    }

    getTimeZones(): Observable<any> {
        return this.apiCommonService.get(`Admin/TimeZoneLookUp`);
    }

    getLoggedUserData() {
        if (localStorage.getItem('oidcCNF')) {
            return JSON.parse(atob(localStorage.getItem('oidcCNF')));
        }
    }

    getUserPermission() {
        const userData = this.getLoggedUserData();
        return userData.userPermission;
    }

    getAccountServices(queryString: any): Observable<any> {
        return this.apiCommonService.get(`Accounts/BrowseServices?${queryString}`);
    }

    saveAccountServices(data: any): Observable<any> {
        return this.apiCommonService.post(`Accounts/AddServices`, data);
    }

    deleteService(data: any) {
        return this.apiCommonService.post(`Accounts/DeleteServices`, data);
    }

    updateAccountServices(data: any) {
        return this.apiCommonService.post(`Accounts/UpdateServices`, data);
    }

    getDimWeightFactors(): Observable<any> {
        return this.apiCommonService.get(`Quotes/DimWeightFactor/Lookup`);
    }

    getConvertToCustomer(queryParam: any): Observable<any> {
        return this.apiCommonService.put(`accounts/ConvertToCustomer`, queryParam);
    }

    getTenants(): Observable<any> {
        return this.apiCommonService.get(`Tenant/Lookup`);
    }

    getRFQDetails(query?: string, orderId?: number): Observable<any> {
        return this.apiCommonService.get(`RFQ/Id${query}&OrderId=${orderId}`);
    }

    createFinalDimsRouting(data: object): Observable<any> {
        return this.apiCommonService.post('Jobs/FinalDims', data);
    }

    getFinalDimsRouting(query: string): Observable<any> {
        return this.apiCommonService.get(`Jobs/FinalDims${query}`);
    }

    getTanentList(): Observable<any> {
        return this.apiCommonService.get(`Tenant/Lookup`);
    }

    convertToJob(data: any) {
        return this.apiCommonService.post('Orders/ConvertToJob', data);
    }

    rejectOrder(data: any) {
        return this.apiCommonService.put('Common/Delete', data);
    }

    containerReset(data: any) {
        return this.apiCommonService.post('Orders/ResetToDefault', data);
    }

    getOrdersHeadersById(queryParams): Observable<any> {
        return this.apiCommonService.get(`Common/HeadersById${queryParams}`);
    }

    getOrderContacts(searchQuery: string): Observable<any> {
        return this.apiCommonService.get(`Common/OrderContacts?${searchQuery}`);
    }

    createQuickCutSheet(data: any) {
        return this.apiCommonService.fileDownloadForPost(`Documents/QuickCutSheet`, data);
    }

    getadminFrechPermissionRoles() {
        return this.apiCommonService.getIdentityRecords(`RolesPermission/PermissionsList`);
    }

    getOrderActivityLogs(requestData: any) {
        return this.apiCommonService.get(`ActivityLog?${requestData}`);
    }

    ////// Roles and Permissions/////
    permissionChecker(permissionList: any) {
        this.permissionDataModelList.filter(list => {
            Object.keys(permissionList).map(key => {
                if (list.permissionName === key) {
                    permissionList[key] = list.isChecked;
                }
            });
        });
        return permissionList;
    }

    permissionCheckByName(permissionName: string) {
        const permission = this.permissionDataModelList.find(x => x.permissionName === permissionName);
        if (permission && permission.isChecked) {
            return true;
        }
        return false;
    }

    setMappedPermissions() {
        if (!CommonService.isUserPermissionMapped) {
            this.mappingPermission();
            CommonService.isUserPermissionMapped = true;
        }
    }
    // Mapping selected permission
    mappingPermission() {
        this.loggedUserModel = this.getLoggedUserData();
        const userPermission = this.getUserPermission();
        const permissionArray = userPermission ? String(userPermission).split(',') : [];
        if (Array.isArray(permissionArray) && permissionArray.length) {
            this.permissionDataModelList.forEach(list => {
                permissionArray.forEach(mapObject => {
                    if (list.permissionId === +mapObject) {
                        list.isChecked = true;
                    }
                });
            });
        }
    }

    getTenantByZip(searchQuery: string): Observable<any> {
        return this.apiCommonService.get(`Tenant/TenantByZip?${searchQuery}`);
    }

    getOrderInShopPendingDetails(filterQuery: string): Observable<any> {
        return this.apiCommonService.get(`Jobs/InShopPendingDetails${filterQuery}`);
    }

    orderInShopAssignee(data: any) {
        return this.apiCommonService.post('Jobs/InShopAssignee', data);
    }

    exportShopGrid(event: any, searchQuery: string, queryString): Observable<object> {
        return this.apiCommonService.export('Jobs/InShop/Export', event, searchQuery, queryString, '');
    }

    getMomentDate(data: any) {
        const lastCharOfValue = data.charAt(data.length - 1);
        (lastCharOfValue.toUpperCase() !== 'Z') ? data += 'Z' : '';
        const convertedData = moment(data).format();
        return convertedData;
    }

    orderAdminRecalc(data: any) {
        return this.apiCommonService.post(`Orders/AdminRecalc`, data);
    }

    getCommonData(): Observable<any> {
        return this.apiCommonService.get(`Orders/commonData`);
    }

    getMappedAccounts(queryParams: string): Observable<any> {
        return this.apiCommonService.get(`Accounts/BrowseAccountByContainers?${queryParams}`);
    }

    getOrderIdUsingStr(data: any) {
        return this.apiCommonService.post('Orders/Search', data);
    }

    deleteAppointment(data: object): Observable<object> {
        return this.apiCommonService.put('Appointment/Activatedeactivate', data);
    }

    getAccountTaxConfiguration(id: string): Observable<object> {
        return this.apiCommonService.get(`Accounts/TaxConfiguration?Id=${id}`);
    }

    statusChangeAccountTaxConfiguration(data: object): Observable<object> {
        return this.apiCommonService.post(`Accounts/IsTaxConfigure`, data);
    }

    updateAccountTaxConfiguration(data: object): Observable<object> {
        return this.apiCommonService.post(`Accounts/UpdateTaxConfig`, data);
    }

    getAppointmentsReportGridRecords(filterQuery: string): Observable<any> {
        return this.apiCommonService.get(`Appointment/TodaysAppointment?${filterQuery}`);
    }

    changeCarrierBuildInTransitStatus(data: any): Observable<any> {
        return this.apiCommonService.post(`Orders/ChangeCarrierBuildInTransitStatus`, data);
    }

    // counter
    getRfqCounter(): Observable<any> {
        return this.apiCommonService.get(`RFQ/StatusCount`);
    }

    fetchUncategorizedServicesCounter(): Observable<any> {
        return this.apiCommonService.get(`Services/UncategorizedServicesCount`).pipe(
            tap(response => this.uncategorizedServicesCountSubject.next(response.data.count)),
            shareReplay(1)
        );
    }

    triggerFetchUncategorizedServicesCounter() {
        this.fetchUncategorizedServicesCounter().subscribe();
    }


    getLocalStorage(key?: string) {
        const localDataAsString = localStorage.getItem('cnflocaldata');
        if (!localDataAsString) {
            return null;
        }
        let localDataObject = JSON.parse(localDataAsString);
        if (key) {
            return localDataObject[key];
        } else {
            return localDataObject;
        }
    }

    setLocalStorage(key: string, data: any) {
        let localDataAsString = localStorage.getItem('cnflocaldata');
        let localDataObject = {};
        if (localDataAsString) {
            localDataObject = JSON.parse(localDataAsString);
        }
        localDataObject[key] = data;
        localStorage.setItem('cnflocaldata', JSON.stringify(localDataObject));
    }

    getAppointmentDetailsById(appointmentId: any) {
        return this.apiCommonService.get(`Appointment/Details?AppointmentId=${appointmentId}`);
    }

    updateAccountIsParticipantsConfigure(data: object): Observable<object> {
        return this.apiCommonService.post(`Accounts/IsParticipantsConfigure`, data);
    }

    getAccountIsExist(searchQuery: string): Observable<string> {
        return this.apiCommonService.get(`Accounts/IsExist?${searchQuery}`);
    }

    bolDataMapping(containerDetails: any) {
        let bolDataObj = {
            quantity: '',
            packageType: '',
            length: '',
            width: '',
            height: '',
            description: '',
            weight: '',
            nmfc: '',
            freightClass: '',
        };
        let bolDataContainer = [];
        if (containerDetails.length > 0) {
            containerDetails.map(element => {
                bolDataObj.packageType = element.containerName;
                bolDataObj.freightClass = element.freightClass;
                bolDataObj.height = element.outerHeight;
                bolDataObj.length = element.outerLength;
                bolDataObj.width = element.outerWidth;
                bolDataObj.quantity = element.quantity;
                bolDataObj.weight = element.unitWeight;
                bolDataObj.description = element.description;
                bolDataObj.nmfc = element.nmfc;
                bolDataContainer.push(bolDataObj);
            });
            return bolDataContainer;
        }
    }

    orderUploadAccountDocument(data: object): Observable<object> {
        return this.apiCommonService.post(`Documents/UploadAccountDocument`, data);
    }


    onSetPickupServiceDataToStorage(response: any): void {
        response.map(item => {
            const serviceName = (item && item.serviceName) ? item.serviceName.toLowerCase() : '';
            const index = serviceName.indexOf('pickup');
            if (index !== -1 && item.isPickupQuantityChanged) {
                this.setLocalStorage('isPickupModified', true);
                this.setLocalStorage('pickupQty', item.quantity);
            }
        });
    }

    getDataForFreightShopper(data: object): Observable<object> {
        return this.apiCommonService.post(`Orders/DataForFreightShopper`, data);
    }

    getRecentQuotesByOrderId(event: any, searchQuery: string): Observable<object> {
        return this.apiCommonService.getGridRecords('Orders/RecentQuotesByOrderId', event, searchQuery, '', '');
    }

    getTenentIsFreightViewIntegrated(): boolean {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.isFreightViewIntegrated;
        }
        return null;
    }

    getTenentIsJobSectionExpandCompress(): boolean {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.isJobSectionExpandCompress;
        }
        return null;
    }

    setTenentIsJobSectionExpandCompress(value: boolean) {
        const localData = localStorage.getItem('oidcCNF');
        if (localData) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            this.oidCNFDetails.isJobSectionExpandCompress = value;
            localStorage.setItem('oidcCNF', btoa(JSON.stringify(this.oidCNFDetails)));
        }
    }

    getTenentIsShipmentOptionEnable(): boolean {
        if (localStorage.getItem('oidcCNF')) {
            this.oidCNFDetails = JSON.parse(atob(localStorage.getItem('oidcCNF')));
            return this.oidCNFDetails.isShipmentOptionEnable;
        }
        return null;
    }

    changeIsAutoFetchFinalDims(data: object): Observable<object> {
        return this.apiCommonService.post(`Orders/UpdateFinalDimsAutoFetch`, data);
    }

    freightViewRating(data: object): Observable<object> {
        return this.apiCommonService.post('FreightView/Rating', data);
    }

    freightViewBooking(data: object): Observable<object> {
        return this.apiCommonService.post(`FreightView/Booking`, data);
    }

    getOrderTrackingDetails(orderId: any): Observable<any> {
        return this.apiCommonService.get(`Orders/OrderTrackingDetails?OrderId=${orderId}`);
    }

    getTrackingSummary(data: object): Observable<object> {
        return this.apiCommonService.post(`Orders/GetTrackingSummary`, data);
    }

    getPackageType(): Observable<any> {
        return this.apiCommonService.get(`Orders/PackageType`);
    }

    getExactHours(hrs: any, minutes: any) {
        if (hrs > 12) {
            return hrs - 12 + ':' + minutes + ' PM';
        } else if (hrs === 12) {
            return hrs + ':' + minutes + ' PM';
        } else if (hrs === 0) {
            return 12 + ':' + minutes + ' AM';
        } else {
            return hrs + ':' + minutes + ' AM';
        }
    }

    addZeroToMinutes(minutes: number) {
        return minutes >= 10 ? minutes : '0' + minutes;
    }

    shipmentAlertEmails(data: object): Observable<object> {
        return this.apiCommonService.post(`Orders/ShipmentAlertEmails`, data);
    }

    getSendShipmentAlertEmails(data: string): Observable<object> {
        return this.apiCommonService.get(`Orders/SendShipmentAlertEmails?OrderId=${data}`);
    }

    getFormattedPhoneNumber(phoneNumber: string) {
        return phoneNumber.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    }

    removeFormattedPhoneNumber(phoneNumber: string) {
        return phoneNumber.replace(/[()\s-]/g, '');
    }

    getStatusId(value: string): number {
        switch (value) {
            case CommonConstants.orderStatusConstants.accepted:
                return 5;
            case CommonConstants.orderStatusConstants.pickup:
                return 6;
            case CommonConstants.orderStatusConstants.redims:
                return 7;
            case CommonConstants.orderStatusConstants.inshop:
                return 8;
            case CommonConstants.orderStatusConstants.complete:
                return 9;
            case CommonConstants.orderStatusConstants.carrierPickup:
                return 10;
            case CommonConstants.orderStatusConstants.intransit:
                return 11;
            case CommonConstants.orderStatusConstants.delivered:
                return 12;
            case CommonConstants.orderStatusConstants.holdAndStorage:
                return 13;
            default: return null;
        }
    }

    getExcessValueClassName(excessValueId: number): string {
        if (excessValueId === ExcessValueTypeEnum.excessValueOne
            || excessValueId === ExcessValueTypeEnum.excessValueFour) {
            return CommonConstants.colorConstants.red;
        } else if (excessValueId === ExcessValueTypeEnum.excessValueTwo) {
            return CommonConstants.colorConstants.yellow;
        } else if (excessValueId === ExcessValueTypeEnum.excessValueThree) {
            return CommonConstants.colorConstants.green;
        } else if (excessValueId === ExcessValueTypeEnum.excessValueFive) {
            return CommonConstants.colorConstants.grey;
        } else {
            return '';
        }
    }

    getCleatsList(queryparam?: any): Observable<any> {
        return this.apiCommonService.get(`Materials/Lookup?${queryparam}`);
    }

    // Dashboard API's

    getBottomTiles(queryparams: any): Observable<any> {
        return this.apiCommonService.get(`Dashboard/BottomTileData?IsActive=true&${queryparams}`);
    }

    getTopTiles(queryparams: any): Observable<any> {
        return this.apiCommonService.get(`Dashboard/TopTileData?IsActive=true&${queryparams}`);
    }

    getDashboardGridRecords(event: any, queryparams: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords(`Dashboard/OrdersPerAccountGridView`, event, queryparams, statusQuery, '');
    }

    getPieChart(queryparams: any): Observable<any> {
        return this.apiCommonService.get(`Dashboard/PieChartData?IsActive=true&${queryparams}`);
    }

    getLineChartData(queryparams: any): Observable<any> {
        return this.apiCommonService.get(`Dashboard/LineChartData?IsActive=true&${queryparams}`);
    }

    // Message Board API's

    getMessageBoardData(): Observable<any> {
        return this.apiCommonService.get(`Dashboard/Message`);
    }

    postMessageBoardData(data: any): Observable<any> {
        return this.apiCommonService.post(`Dashboard/UpdateMessage`, data);
    }

    deleteMessageBoard(data: any): Observable<any> {
        return this.apiCommonService.post(`Dashboard/DeleteMessage`, data);
    }

    getIndividualMessages(isIndividual: any, isView: any, isAllFranchise: any): Observable<any> {
        return this.apiCommonService.get(`Dashboard/Message?IsIndividual=${isIndividual}&IsView=${isView}&IsAllFranchise=${isAllFranchise}`)
    }

    getForumsMessageBoardData(tenantId: any): Observable<any> {
        return this.apiCommonService.get(`Dashboard/Message?tenantId=${tenantId}`);
    }

    // Retain modifier API's

    getRetainCategoriesList(orderId: any, itemContainerId: any): Observable<any> {
        return this.apiCommonService.get(`Container/RetainModifierContainerLookUp?OrderId=${orderId}&ItemContainerId=${itemContainerId}`);
    }

}
